import { request } from '.';
import { setUiState } from './ui';

const SET_USERS = 'SET_USERS';
const SET_USER = 'SET_USER';
const SET_META = 'SET_META';

const defaultState = { users: null, user: null, meta: null };

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_USERS:
      return { ...state, users: action.payload, user: null };

    case SET_USER:
      return { ...state, user: action.payload };
    case SET_META:
      return { ...state, meta: action.payload };
    default:
      return state;
  }
}

export function setUsers(users) {
  return {
    type: SET_USERS,
    payload: users
  };
}

export function setUser(user) {
  return {
    type: SET_USER,
    payload: user
  };
}
export function setMeta(meta) {
  return {
    type: SET_META,
    payload: meta
  };
}
export function getUsers(params) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/users`;

        dispatch(setUiState('loading'));
        const response = await request.get(url, { params });
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }
        const meta = {
          count: Number(response.headers['juven-count']) || 0,
          from: Number(response.headers['juven-from']) || 0,
          to: Number(response.headers['juven-to']) || 0
        };
        dispatch(setMeta(meta));
        dispatch(setUsers(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function getUser(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/users/user/${id}`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));

        dispatch(setUser(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        console.error(e);
      }
    });
  };
}
export function sendResetPasswordMail(data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/users/forgot_password`;

        dispatch(setUiState('loading'));
        await request.post(url, data);
        dispatch(setUiState('complete'));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function updateUser(id, data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/users/user/${id}`;
        dispatch(setUiState('loading'));
        await request.put(url, data);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function updateUserPassword(id, data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/users/change_password/${id}`;
        dispatch(setUiState('loading'));
        await request.put(url, data);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/users.js